
import AgeLine from './Ageline';
import { Box, Typography } from '@mui/material';

const AgeLineChartList = ({ chronologicalAge, data }) => {
  
    return (
    
    <Box>
      
      {data.map((point, idx) => (
        <AgeLine
          key={idx}
          chronologicalAge={chronologicalAge}
          dataPoint={point}
        />
      ))}
    </Box>
  );
};

export default AgeLineChartList;
